module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"label":"Confirm password"},"fr_FR":{"label":"Confirmation du mot de passe"}}')
  delete Component.options._Ctor
}
